import gnb from "./gnb";
import orgmap from "./orgmap";
import common from "./common";
import sms from "./sms";
import worlfow from "./workflow";

export default {
    gnb,
    orgmap,
    common,
    sms,
    worlfow,
};
